import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import { jsx as _jsx } from "react/jsx-runtime";
var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32"
  }, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      d: "M24.707 11h-9.061l-2.4-2.341a2.468 2.468 0 0 0-2.717-.514A2.466 2.466 0 0 0 9 10.449V24h1V10.449c0-.733.474-1.195.917-1.382a1.476 1.476 0 0 1 1.63.309l2.45 2.39.003-.003v8.944L24.707 11zM16 12h6.293L16 18.293V12zm1.646 8.353.708-.705 1.607 1.613-.708.705zm6.002-5.998.705-.711 1.68 1.666-.705.71zm-4.002 3.999.707-.707 3 3-.706.707zm2-2 .707-.707 3 3-.706.707z",
      fill: "currentColor"
    })
  }));
};
export default SvgComponent;